import React, { forwardRef, useRef, useImperativeHandle } from "react";
import { Container } from "@pixi/react";

export const FreeSpinOverlaySymbol = forwardRef(({ index, y }, ref) => {
  const containerRef = useRef(null);

  // Expose container ref directly (same pattern as main OverlaySymbol)
  useImperativeHandle(ref, () => containerRef.current);

  return (
    <Container
      ref={containerRef}
      y={y}
      x={0}
      zIndex={6}
      sortableChildren
      name={`freespin_spine_overlay_symbol_${index}`}
    />
  );
});

export default FreeSpinOverlaySymbol;
